module.exports = "/fonts/opensanssemibolditalic.woff2";